import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { updateActions } from '../actions/update.actions';
import { selectPending, selectStatus } from '../selectors/update.selector';

@Service()
export class UpdateFacade {
    private readonly store = inject(Store);

    readonly status = this.store.selectSignal(selectStatus);

    readonly pending = this.store.selectSignal(selectPending);

    check(): void {
        this.store.dispatch(updateActions.check());
    }

    apply(): void {
        this.store.dispatch(updateActions.apply());
    }

    restoreLock(): void {
        this.store.dispatch(updateActions.restoreLock());
    }
}
